module.exports = __webpack_public_path__ + "static/media/title1.60c145ca.png";